var ModelConstants = require('./constants/ModelConstants.js');
var ReactNative = require('react-native');

var moment = require('moment');

var {Platform} = ReactNative;
var LocalizationManager =
{
  _appManager: null,
  _modelConstants: ModelConstants,
  _defaultCurrency : "CAD",
  setAppManager: function(appManager)
  {
    this._appManager = appManager;
  },

	getLocalizedStrings: function()
	{
    var activeLocale = this._appManager.getActiveLocale();
    if ( typeof activeLocale !== 'undefined' && activeLocale !== "" ) return this._appManager.getAppData()["LocalizedStrings-" + activeLocale];

		return this._appManager.getAppData()["LocalizedStrings"];
	},

	getConstants: function()
	{
		return this._appManager.getAppData()["Constants"];
	},

	getFeatureDict: function()
	{
		return this._appManager.getFeatureDict();
	},

	getCurrentUser: function()
	{
    var user = this._appManager.currentUser();

		return user != null ? user : {};
	},

	getEligibleRefunds: function()
	{
		// TODO: implement refunds
		return null;
  },
  
  shouldShowKey: function() 
  {
    return this._appManager._shouldShowLocKeys;
  },

	localizedStringForKeyAndParams: function(key, params, fallback)
	{
    if( this.shouldShowKey() ) return key;
    
		if( typeof key === 'undefined' ) return "";

		var outputString = "";
		var components = key.split("%");
		for( var i = 0; i < components.length; i++ )
		{
			var component = components[i];
			var result = null;

			if( component.length <= 0 ) continue;

			if( typeof this.getLocalizedStrings()[component] !== 'undefined' )
			{
				result = this.localizedStringForKeyAndParams(this.getLocalizedStrings()[component], params);
			}
			else if( component.search("FEATURENAME_") >= 0 )
			{
				var featureClassName = component.replace("FEATURENAME_", "");
				var feature = this.getFeatureDict()[featureClassName];
				result = feature["title"];
			}
			else if( component == "POINTS_LEFT" )
			{
				result = this.getCurrentUser()[this._modelConstants.Points];
			}
			else if( component == "REFUNDS_ELIGIBLE" )
			{
				result = this.getEligibleRefunds().length;
			}
			else if( component == "POINTS_FOR_REWARD" )
			{
				// not implemented anymore
			}
			else if( component == "CREDITS_LEFT" )
			{
        var key = this._modelConstants.Credits;
				result = this.localizedDollars(this.getCurrentUser()[key]);
			}
			else if( component == "REWARDS_LEFT" )
			{
				// not implemented anymore
			}
			else if( component == "REWARD_NAME_CONTEXTUAL" )
			{
				// not implemented anymore
			}
			else if( component == "POINTS_REQUIRED_NAME_CONTEXTUAL" )
			{
				// not implemented anymore
			}
			else if( component == "POINTS_NAME_CONTEXTUAL")
			{
				var numPoints = parseInt(this.getCurrentUser()[this._modelConstants.Points]);
				if( numPoints == 1 ) result = this.localizedStringForKey("POINTS_NAME_SINGULAR");
				else result = this.localizedStringForKey("POINTS_NAME_PLURAL");
			}
			else if( component == "POINTS_REQUIRED" )
			{
				// not implemented anymore
			}
			else if( typeof this.getConstants()[component] !== 'undefined' )
			{
				result = this.getConstants()[component];
			}
			else
			{
				var periodComponents = component.split(".");
				if( periodComponents.length > 1 )
				{
					if( periodComponents[0] == "User" )
					{
						if( this.getCurrentUser() && typeof this.getCurrentUser()[periodComponents[1]] !== 'undefined')
						{
							var value = this.getCurrentUser()[periodComponents[1]];
							if( typeof value !== 'undefined' )
							{
								if( periodComponents.length > 2 )
								{
									if( periodComponents[2] == "Dollars" ) result = this.localizedDollars(parseFloat(value));
									else if( periodComponents[2] == "Points" ) result = this.localizedPoints(parseFloat(value));
								}
								else
								{
									result = value;
								}
							}
						}
					}
					else
					{
						var feature = this.getFeatureDict()[periodComponents[0]];
						if( typeof feature !== 'undefined' && typeof feature.data[periodComponents[1]] !== 'undefined' )
						{
							result = this.localizedStringForKeyAndParams(feature.data[periodComponents[1]], params);
						}
					}
				}
				else if( params != null && typeof params !== 'undefined' )
				{
					for( var j = 0; j < params.length; j++ )
					{
						if( component == (j + "") )
						{
							result = params[j];
							break;
						}
					}
				}
			}

			if( result != null )
			{
				outputString += result;
			}
			else
			{
				// TODO: re-enable percent signs.  I can't figure this out right now.
// 				if( component != components[0] ) outputString += "%";
				outputString += component;
// 				if( component != components[components.length-1] ) outputString += "%";
			}
		}

		return typeof fallback === 'undefined' || outputString != key ? outputString : this.localizedStringForKeyAndParams(fallback, params);
	},

  localizedDollarSymbol: function()
  {
    var currencySign = this._appManager.getCurrencySign();

    return currencySign;
  },

  shouldUseComma: function()
  {
    return this._appManager != null && typeof this._appManager.getDeviceInfo().locale !== 'undefined' && this._appManager.getDeviceInfo().locale == "fr-CA";
  },

	localizedDollars: function(price)
	{
    var currencySign = this.localizedDollarSymbol();
    var shouldUseComma = this.shouldUseComma();
    if( shouldUseComma )
    {
      if( typeof price === 'undefined' ) return currencySign + "0,00";
      if( typeof price === 'string' )
      {
        price = price.replace(",",".");
        price = parseFloat(price);
      }

      var isNegative = price < 0;
      price = Math.abs(price)

      var strPrice = price.toFixed(2).toString();
      strPrice = strPrice.replace(".",",");

      return (isNegative ? "-" : "") + strPrice + " " + currencySign;
    }

    if( typeof price === 'undefined' ) return currencySign + "0.00";
    if( typeof price === 'string' )
    {
      price = price.replace(",","");
      price = parseFloat(price);
    }

    var isNegative = price < 0;
    price = Math.abs(price)

    var strPrice = price.toFixed(2).toString();
    var a = strPrice.split('');
    a = (typeof a === 'undefined' || a == null) ? "" : a;
    if (price > 1000000000)
      a.splice(a.length - 12, 0, ',');

    if (price > 1000000)
      a.splice(a.length - 9, 0, ',');

    if (price > 1000)
      a.splice(a.length - 6, 0, ',');

    return (isNegative ? "-" : "") + currencySign + a.join("");
	},

  localizedDollarsShort: function(price)
  {
    var localized = this.localizedDollars(price);
    if( localized.substring(localized.length - 3) == ".00" ) return localized.substring(0, localized.length-3);

    return localized;
  },

  localizedPhone: function(phoneString)
  {
    if( !this.isValidPhone(phoneString) ) return phoneString;

    return phoneString.substring(0,1) + "-" + phoneString.substring(1,4) + "-" + phoneString.substring(4,7) + "-" + phoneString.substring(7,11);
  },

  isValidPhone: function(phoneNumber)
  {
    if( phoneNumber.length != 11 ) return false;
    if( isNaN(phoneNumber) ) return false;

    return true;
  },

  localizedDistance: function(distanceM)
  {
    if( this._defaultDistance == "feet" )
    {
      distanceM = parseFloat(distanceM);
      var distanceF = 3.28084 * distanceM;
      var distanceMiles = parseFloat(distanceF / 5280);
      if( distanceMiles > 1 ) return distanceMiles.toFixed(2) + " mi.";

      return distanceF.toFixed(2) + " ft";
    }

    distanceM = parseFloat(distanceM);
    if( distanceM >= 1000 ) return (distanceM/1000).toFixed(2) + " km";

    return distanceM.toFixed(2) + " m";
  },

  localizedTime: function(timeString)
  {
    var timeStringLower = timeString.toLowerCase();
    var is12hr = (timeStringLower.indexOf("am") >= 0) || (timeStringLower.indexOf("pm") >= 0);
    if( is12hr )
    {
      if( this._defaultTime == "12" ) return timeString;

      // convert 12 -> 24
      var isAM = timeStringLower.indexOf("am") >= 0;
      if( isAM )
      {
        var strippedTimeString = timeStringLower.replace("am", "").trim();
        var timeStringParts = strippedTimeString.split(":");
        if( timeStringParts.length != 2 ) return timeString;

        var hoursString = timeStringParts[0];
        var minutesString = timeStringParts[1];
        if( hoursString.length <= 0 || minutesString.length <= 0 ) return timeString;

        return (parseInt(hoursString) + (parseInt(hoursString) == 12 ? 12 : 0)) + ":" + minutesString;
      }
      else
      {
        var strippedTimeString = timeStringLower.replace("pm", "").trim();
        var timeStringParts = strippedTimeString.split(":");
        if( timeStringParts.length != 2 ) return timeString;

        var hoursString = timeStringParts[0];
        var minutesString = timeStringParts[1];
        if( hoursString.length <= 0 || minutesString.length <= 0 ) return timeString;

        return (parseInt(hoursString) + (parseInt(hoursString) != 12 ? 12 : 0)) + ":" + minutesString;
      }
    }
    else // is 24 times
    {
      // convert 24 -> 12
      var strippedTimeString = timeStringLower.trim();
      var timeStringParts = strippedTimeString.split(":");
      if( timeStringParts.length != 2 ) return timeString;

      var hoursString = timeStringParts[0];
      var minutesString = timeStringParts[1];
      if( hoursString.length <= 0 || minutesString.length <= 0 ) return timeString;

      if( this._defaultTime == "24" )
      {
        return (parseInt(hoursString) == 0 ? "24" : hoursString) + ":" + minutesString;
      }

      var isAM = (parseInt(hoursString) == 24) || (parseInt(hoursString) < 12)
      var newHours = (parseInt(hoursString)%12);
      if( newHours == 0 ) newHours = 12;
      return newHours + ":" + minutesString + (isAM ? " am" : " pm");
    }

    return timeString;
  },

	localizedPoints: function(points)
	{
		if( typeof points === 'undefined' ) return "0 " + this.localizedStringForKey("POINTS_NAME_PLURAL");
        if( typeof points === 'string' ) points = parseFloat(points);

		if( points == 1 )
		{
			return points + " " + this.localizedStringForKey("POINTS_NAME_SINGULAR");
		}
		else
		{
      return points + " " + this.localizedStringForKey("POINTS_NAME_PLURAL");
		}
	},

	localizedPts: function(points)
	{
		if( typeof points === 'undefined' ) return "0 " + this.localizedStringForKey("POINTS_NAME_SHORT_PLURAL");
    if( typeof points === 'string' ) points = parseFloat(points);

		if( points == 1 )
		{
			return points + " " + this.localizedStringForKey("POINTS_NAME_SHORT_SINGULAR");
		}
		else
		{
			return points + " " + this.localizedStringForKey("POINTS_NAME_SHORT_PLURAL");
		}
	},

	localizedRewards: function(rewards)
	{
		// not needed
		return "";
	},

  localizedLongDate: function(dateString)
  {
    this.setupMomentLocale();
    var now = moment(dateString).fromNow();

    return now;
  },

  localizedLongDateFuture: function(dateString)
  {
    this.setupMomentLocale();
    var now = moment(dateString).fromNow();

    return now;
  },

  localizedDate: function(dateString)
  {
    var now = moment(dateString).format("MMMM DD, YYYY");

    return now;
  },

  dateTime: function(dateString)
  {
    var now = moment(dateString).format('MMM DD, YYYY HH:mm');

    return now;
  },

  dateTimeGrabb: function(dateString)
  {
    var now = moment(dateString).format('YYYY-MM-DDTHH:mm:ss');

    return now;
  },

  dateTimeAuphan: function(dateString)
  {
    var now = moment(dateString).format('YYYY-MM-DD');

    return now;
  },

  dateTimeReUp: function(dateString)
  {
    var now = moment(dateString).format('YYYY-MM-DD');

    return now;
  },

  nameOfDay: function(dayNumber)
  {
    this.setupMomentLocale();

    return moment().weekday(dayNumber).format('dddd');
  },

  setupMomentLocale: function()
  {
    if( this._appManager != null )
    {
      var locale = (Platform.OS == "web" ? (window.navigator.userLanguage || window.navigator.language) : this._appManager.getDeviceInfo().locale);
      if( locale.indexOf("fr-") === 0 )
      moment.locale('fr', {
          months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
          monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
          monthsParseExact : true,
          weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
          weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
          weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
          weekdaysParseExact : true,
          longDateFormat : {
              LT : 'HH:mm',
              LTS : 'HH:mm:ss',
              L : 'DD/MM/YYYY',
              LL : 'D MMMM YYYY',
              LLL : 'D MMMM YYYY HH:mm',
              LLLL : 'dddd D MMMM YYYY HH:mm'
          },
          calendar : {
              sameDay : '[Aujourd’hui à] LT',
              nextDay : '[Demain à] LT',
              nextWeek : 'dddd [à] LT',
              lastDay : '[Hier à] LT',
              lastWeek : 'dddd [dernier à] LT',
              sameElse : 'L'
          },
          relativeTime : {
              future : 'dans %s',
              past : 'il y a %s',
              s : 'quelques secondes',
              m : 'une minute',
              mm : '%d minutes',
              h : 'une heure',
              hh : '%d heures',
              d : 'un jour',
              dd : '%d jours',
              M : 'un mois',
              MM : '%d mois',
              y : 'un an',
              yy : '%d ans'
          },
          dayOfMonthOrdinalParse : /\d{1,2}(er|e)/,
          ordinal : function (number) {
              return number + (number === 1 ? 'er' : 'e');
          },
          meridiemParse : /PD|MD/,
          isPM : function (input) {
              return input.charAt(0) === 'M';
          },
          // In case the meridiem units are not separated around 12, then implement
          // this function (look at locale/id.js for an example).
          // meridiemHour : function (hour, meridiem) {
          //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
          // },
          meridiem : function (hours, minutes, isLower) {
              return hours < 12 ? 'PD' : 'MD';
          },
          week : {
              dow : 0, // Sunday is the first day of the week.
              doy : 4  // The week that contains Jan 4th is the first week of the year.
          }
      })
    }
  },

	localizedStringForKey: function(key, fallback)
	{
    if( this.shouldShowKey() ) return key;

    var result = this.localizedStringForKeyAndParams(key, []);

		return typeof fallback === 'undefined' || result != key ? result : fallback;
	},

	localizedStringForKeyParams: function(keyParams)
	{
		if( keyParams.length <= 0 ) return "";
		var key = keyParams[0];
		var params = []
		for( var i = 1; i < keyParams.length; i++ )
		{
			params.push(keyParams[i]);
		}

		return this.localizedStringForKeyAndParams(key, params);
	},

};

module.exports = LocalizationManager;
